(function () {
    function parseBound(value, fallback) {
        const num = Number(value);
        return Number.isFinite(num) ? num : fallback;
    }

    function stepQuantity(input, direction) {
        if (!input || input.readOnly || input.disabled || input.type === 'hidden') {
            return;
        }

        const step = Math.max(parseBound(input.getAttribute('step'), 1), 0.0001);
        const min = parseBound(input.getAttribute('min'), 0);
        const maxAttr = input.getAttribute('max');
        const max = maxAttr === null || maxAttr === '' ? null : parseBound(maxAttr, null);
        const current = parseBound(input.value, min || 1);
        let next = direction < 0 ? current - step : current + step;

        next = Math.round(next / step) * step;

        if (next < min) {
            next = min;
        }
        if (max !== null && next > max) {
            next = max;
        }

        if (String(next) === String(input.value)) {
            return;
        }

        input.value = String(next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    document.addEventListener('click', (event) => {
        const minus = event.target.closest('[data-quantity-minus]');
        const plus = event.target.closest('[data-quantity-plus]');

        if (!minus && !plus) {
            return;
        }

        event.preventDefault();

        const wrap = (minus || plus).closest('.quantity');
        const input = wrap?.querySelector('input.qty, input[name="quantity"]');
        if (!input) {
            return;
        }

        stepQuantity(input, minus ? -1 : 1);
    });

    const CHEVRON =
        '<svg class="rs-select__chevron" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M4.2 6.2 8 10l3.8-3.8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function optionLabel(option) {
        return (option.textContent || option.label || option.value || '').trim();
    }

    function syncTrigger(root) {
        const select = root.querySelector('select');
        const valueEl = root.querySelector('.rs-select__value');
        if (!select || !valueEl) {
            return;
        }

        const selected = select.options[select.selectedIndex];
        const placeholder = select.getAttribute('data-show_option_none') === 'yes'
            ? (select.options[0] ? optionLabel(select.options[0]) : '')
            : '';
        const label = selected ? optionLabel(selected) : placeholder;
        const isPlaceholder = !select.value;

        valueEl.textContent = label || '—';
        root.classList.toggle('is-placeholder', isPlaceholder);
        root.classList.toggle('is-disabled', select.disabled);
    }

    function rebuildOptions(root) {
        const select = root.querySelector('select');
        const list = root.querySelector('.rs-select__list');
        if (!select || !list) {
            return;
        }

        list.replaceChildren();

        Array.from(select.options).forEach((option, index) => {
            if (option.disabled && !option.value) {
                // Keep empty placeholder in native select; skip as choosable list item
                // only when it's the "Choose an option" empty value — still show it.
            }

            const item = document.createElement('button');
            item.type = 'button';
            item.className = 'rs-select__option';
            item.setAttribute('role', 'option');
            item.dataset.value = option.value;
            item.dataset.index = String(index);
            item.textContent = optionLabel(option) || '—';
            item.disabled = option.disabled || option.classList.contains('disabled');
            item.setAttribute('aria-selected', option.selected ? 'true' : 'false');

            if (!option.value) {
                item.classList.add('rs-select__option--placeholder');
            }
            if (option.selected) {
                item.classList.add('is-selected');
            }
            if (item.disabled) {
                item.classList.add('is-disabled');
            }

            list.appendChild(item);
        });

        syncTrigger(root);
    }

    function closeSelect(root) {
        root.classList.remove('is-open');
        const trigger = root.querySelector('.rs-select__trigger');
        const list = root.querySelector('.rs-select__list');
        if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
        }
        if (list) {
            list.hidden = true;
        }
    }

    function openSelect(root) {
        document.querySelectorAll('.rs-select.is-open').forEach((el) => {
            if (el !== root) {
                closeSelect(el);
            }
        });

        root.classList.add('is-open');
        const trigger = root.querySelector('.rs-select__trigger');
        const list = root.querySelector('.rs-select__list');
        if (trigger) {
            trigger.setAttribute('aria-expanded', 'true');
        }
        if (list) {
            list.hidden = false;
        }
    }

    function wrapSelect(select) {
        if (!select || select.closest('.rs-select')) {
            return select.closest('.rs-select');
        }

        const root = document.createElement('div');
        root.className = 'rs-select';
        root.dataset.rsSelect = '';

        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'rs-select__trigger';
        trigger.setAttribute('aria-haspopup', 'listbox');
        trigger.setAttribute('aria-expanded', 'false');

        const valueEl = document.createElement('span');
        valueEl.className = 'rs-select__value';
        trigger.appendChild(valueEl);
        trigger.insertAdjacentHTML('beforeend', CHEVRON);

        const list = document.createElement('div');
        list.className = 'rs-select__list';
        list.setAttribute('role', 'listbox');
        list.hidden = true;

        select.parentNode.insertBefore(root, select);
        root.appendChild(select);
        root.appendChild(trigger);
        root.appendChild(list);

        select.classList.add('rs-select__native');
        select.setAttribute('tabindex', '-1');
        select.setAttribute('aria-hidden', 'true');

        rebuildOptions(root);
        return root;
    }

    function enhanceVariationSelects(scope) {
        const rootScope = scope || document;
        rootScope
            .querySelectorAll('form.variations_form .variations select')
            .forEach((select) => wrapSelect(select));
    }

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('.rs-select__trigger');
        if (trigger) {
            const root = trigger.closest('.rs-select');
            if (!root || root.classList.contains('is-disabled')) {
                return;
            }
            event.preventDefault();
            if (root.classList.contains('is-open')) {
                closeSelect(root);
            } else {
                rebuildOptions(root);
                openSelect(root);
            }
            return;
        }

        const optionBtn = event.target.closest('.rs-select__option');
        if (optionBtn) {
            const root = optionBtn.closest('.rs-select');
            const select = root?.querySelector('select');
            if (!root || !select || optionBtn.disabled) {
                return;
            }

            event.preventDefault();
            const nextValue = optionBtn.dataset.value ?? '';
            if (select.value !== nextValue) {
                select.value = nextValue;
                select.dispatchEvent(new Event('change', { bubbles: true }));
                if (window.jQuery) {
                    window.jQuery(select).trigger('change');
                }
            }
            rebuildOptions(root);
            closeSelect(root);
            return;
        }

        if (!event.target.closest('.rs-select')) {
            document.querySelectorAll('.rs-select.is-open').forEach(closeSelect);
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            document.querySelectorAll('.rs-select.is-open').forEach(closeSelect);
        }
    });

    function bindWooEvents() {
        if (!window.jQuery) {
            return;
        }

        const $ = window.jQuery;
        $(document.body).on(
            'woocommerce_update_variation_values check_variations reset_data show_variation hide_variation',
            'form.variations_form',
            function () {
                enhanceVariationSelects(this);
                this.querySelectorAll('.rs-select').forEach((root) => {
                    rebuildOptions(root);
                    if (!root.classList.contains('is-open')) {
                        closeSelect(root);
                    }
                });
            }
        );

        $(document.body).on('click', 'form.variations_form .reset_variations', function () {
            const form = this.closest('form.variations_form');
            if (!form) {
                return;
            }
            window.setTimeout(() => {
                enhanceVariationSelects(form);
                form.querySelectorAll('.rs-select').forEach((root) => {
                    rebuildOptions(root);
                    closeSelect(root);
                });
            }, 0);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            enhanceVariationSelects();
            bindWooEvents();
        });
    } else {
        enhanceVariationSelects();
        bindWooEvents();
    }
})();
